
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2V0h-2v1.2c0 .44-.36.8-.8.8H2.8c-.44 0-.8-.36-.8-.8V0H0v2c0 .204.032.404.088.592v.004A2.009 2.009 0 002 4h8c.896 0 1.656-.592 1.912-1.404v-.004C11.968 2.404 12 2.204 12 2zm-1.152 6L12 6H8.692L7.536 8l-1.152 2h-.768v-.004L4.464 8 3.308 6H0l1.156 2h1l2.092 4h3.504l2.164-4h.932z","fill":"currentColor"}})])
          )
        }
      }
    